import React from "react";
import { formatDateTime } from "../../../utils/format";
import { useNavigate, useParams } from "react-router-dom";
import {
  useDeleteHospital,
  useHospitalById,
} from "../../../api/member-management/use-hospital-detail";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";
import Modal from "../../../components/ui/Modal/Modal";
import { convertSecondsToDate } from "../../../helper/formatDate/formate-date";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import Navigation from "./Components/navigation";
import HospitalMemberTable from "./HospitalMemberTable";

const HospitalDetailItemPage = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useHospitalById(id);
  const hospital = data?.data;
  const { mutate: deleteHospital } = useDeleteHospital();
  const images = hospital?.images;

  const onEdit = () => {
    navigate("edit");
  };

  const handleBackToList = () => {
    navigate("/hospital");
  };

  const handleDeleteHospital = async () => {
    try {
      await deleteHospital(id);
    } catch (error) {}
  };

  return (
    <div>
      <TitlePage title="회원조회 > 회원상세" />
      <Navigation id="detail" hospitalId={id} />
      <div className="pb-44 mt-8">
        <div className="flex flex-col lg:flex-row gap-[15px] justify-between">
          <div className="lg:w-[25%] w-full">
            <div
              style={{
                boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
              }}
              className="rounded-[2px] p-[10px]"
            >
              <div className="mx-auto w-full h-[300px]">
                <img
                  src={images?.find((_, idx) => idx === 0)}
                  alt="hospital"
                  className="object-cover  w-full h-full"
                />
              </div>
              <div className="grid grid-cols-4 gap-1 mt-[10px] justify-start flex-wrap">
                {images?.map((val, index) => (
                  <div
                    key={`${index}-${val ?? ""}`}
                    className="w-full h-[70px]"
                  >
                    <img
                      src={val}
                      alt="hospital"
                      className="object-cover mx-auto w-full h-full"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="lg:w-[75%] w-full">
            <div>
              <div className="flex items-center">
                <div className="w-1/2">
                  <FieldBox splitted splittedWidth="w-[50%]" label="병원명">
                    <span className="p-2">{hospital?.name}</span>
                  </FieldBox>
                </div>
                <div className="w-1/2">
                  <FieldBox
                    splitted
                    splittedWidth="w-[50%]"
                    label="가입일시 (탈퇴일시)"
                  >
                    <span className="p-2">
                      {hospital?.createdAt
                        ? formatDateTime(hospital?.createdAt)
                        : "-"}
                    </span>
                  </FieldBox>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-1/2">
                  <FieldBox
                    splitted
                    splittedWidth="w-[50%]"
                    label="사업자 등록번호 / 면허 번호"
                  >
                    <span className="p-2">
                      {hospital?.regNo}/{hospital?.licenseNo}
                    </span>
                  </FieldBox>
                </div>
                <div className="w-1/2">
                  <FieldBox
                    splitted
                    splittedWidth="w-[50%]"
                    label="마지막 주문일시"
                  >
                    <span className="p-2">
                      {hospital?.lastOrderedAt
                        ? formatDateTime(hospital?.lastOrderedAt)
                        : "-"}
                    </span>
                  </FieldBox>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-1/2">
                  <FieldBox splitted splittedWidth="w-[50%]" label="대표자명">
                    <span className="p-2">{hospital?.ceoName}</span>
                  </FieldBox>
                </div>
                <div className="w-1/2">
                  <FieldBox
                    splitted
                    splittedWidth="w-[50%]"
                    label="소속 직원수 / 등록 환자수"
                  >
                    <span className="p-2">
                      {hospital?.membersQnt ? hospital?.membersQnt : "-"} /{" "}
                      {hospital?.patientsQnt ? hospital?.patientsQnt : "-"}
                    </span>
                  </FieldBox>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-1/2">
                  <FieldBox splitted splittedWidth="w-[50%]" label="전화번호">
                    <span className="p-2">{hospital?.contact}</span>
                  </FieldBox>
                </div>
                <div className="w-1/2">
                  <FieldBox
                    splitted
                    splittedWidth="w-[50%]"
                    label="대표자 / 담당자 연락처"
                  >
                    <span className="p-2">
                      {hospital?.ceoPhone ? hospital?.ceoPhone : "-"}/{" "}
                      {hospital?.contact ? hospital?.contactUs : "-"}
                    </span>
                  </FieldBox>
                </div>
              </div>
              <FieldBox unSplittedWidth="w-[19.4%]" label="주소">
                <span className="p-2">{hospital?.address}</span>
              </FieldBox>
              <FieldBox unSplittedWidth="w-[19.4%]" label="영업시간">
                <p className="p-2 min-h-[37px]">
                  {hospital?.openHours?.map((val, i) => (
                    <span key={`${i}-${val ?? ""}`}>{val}, &nbsp;</span>
                  ))}
                </p>
              </FieldBox>
              <FieldBox unSplittedWidth="w-[19.4%]" isLast label="상세정보">
                <p className="p-2 min-h-[60px]">{hospital?.details}</p>
              </FieldBox>
            </div>
          </div>
        </div>

        <div className="flex justify-end w-full mt-[16px]">
          <Button
            type="button"
            onClick={handleBackToList}
            className="border border-title-black w-[80px]"
            text="목록"
          />
          <Button
            className="border border-title-black"
            text="병원 정보 변경"
            onClick={onEdit}
          />
          <Modal
            widthSubmitButton="w-auto"
            width="w-[450px]"
            maxWidth="max-w-[450px]"
            bgSubmit="bg-[#e63c38]"
            submitText="대표계정 삭제"
            description={
              <div className="px-3 py-1">
                해당 대표계정을 삭제하시겠습니까?
                <br />
                대표계정을 삭제할 경우, 해당 회원은 전체 소속 직원 정보도
                동일하게 삭제
                <br />
                처리 되어 접근이 불가능하고, 병원에 등록된 환자 정보는
                보존됩니다.
                <br />
                신중한 선택 부탁드립니다.
                <ol className="mt-4">
                  ■ 대표계정 및 소속 직원 삭제
                  <li>
                    1. 임플란트 보증서 및 주문내역이 존재할 경우 - 데이터 보존
                  </li>
                  <li>2. 등록된 환자가 존재할 경우 - 데이터 보존</li>
                  <li>
                    3. 삭제된 대표계정 및 소속 직원 정보 - 삭제처리(복구 불가).
                    이력관리 위해
                    <br />
                    데이터 보존, 동일한 이메일주소로 가입 불가
                  </li>
                </ol>
              </div>
            }
            onSubmit={handleDeleteHospital}
          >
            <Button
              className="border border-title-black"
              text="대표계정 삭제"
            />
          </Modal>
        </div>

        <div className="mt-4">
          <div className="flex justify-between items-center">
            <h2 className="text-black text-[14px] font-bold">소속 직원 정보</h2>
          </div>
          <div className="mt-[10px]">
            <HospitalMemberTable data={hospital?.hospitalMember} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HospitalDetailItemPage;
